import CRMProcessBody from "components/CRMComponents/CRMProcessComponents/CRMProcessBody/CRMProcessBody";
import Header from "components/Common/Header/Header";
import React, { useEffect } from "react";

const CrmProcess = () => {
  useEffect(() => {
    document.title = "CRM | Process";
  }, []);
  return (
    <main id="app">
      {/* ---- header component ---- */}
      <Header moduleName="crm" />

      {/* --- body section --- */}
      <CRMProcessBody />
    </main>
  );
};

export default CrmProcess;
